<template>
	<div id="send_low_value_wedding_recommendation_widget" v-loading="loading">
		<div class="recommendation-container">
			<div
				v-for="(option, index) in quickRecommendations"
				:key="index"
				:class="['option-box', { selected: index === selectedIndex }]"
				@click="selectOption(index)"
			>
				<h3 :class="{ 'selected-title': index === selectedIndex }" class="selected-option hidden">
					SELECTED
				</h3>
				<h3 :class="{ 'selected-option-number': index === selectedIndex }">
					Option {{ index + 1 }}
				</h3>
				<p>
					<div><strong>Budget:</strong> up to £{{ option.budget }}</div>
					<div><strong>Guests:</strong> {{ option.guests }}</div>
				</p>

				<ul class="venue-list">
					<li v-for="(venue, vIndex) in option.venues" :key="venue.name + vIndex" class="venue-item">
						<img :src="venue.image" alt="venue" class="venue-image" />
						<span>{{ venue.name }}</span>
					</li>
				</ul>
			</div>
		</div>

		<div style="text-align: center; margin-top: 20px;">
			<el-button type="primary" @click="sendRecommendations">Send Recommendations</el-button>
		</div>
	</div>
</template>

<script>
import recommendationMixin from "@/helpers/recommendationMixin";
import { Button } from "element-ui";

export default {
	components: {
		[Button.name]: Button,
	},
	props:{
		leadEventId: {
			required: true
		},
	},
	data() {
		return {
			loading: true,
			selectedIndex: 0,
		};
	},
	mixins: [ recommendationMixin ],
	computed: {
		leadInfo() {
			return this.$store.getters["leadEvent/getLeadEventsById"](this.leadEventId);
		},
		quickRecommendations() {
			return this.$store.getters["recommendations/getQuickRecommendations"];
		},
		emailTemplate() {
			return this.ukQuickEmailTemplate;
		},
	},
	async mounted() {
		await this.$store.dispatch("leadEvent/getSingle", this.leadEventId);
		await this.$store.dispatch("recommendations/getQuickRecommendations");
		this.loading = false;
	},
	methods: {
		selectOption(index) {
			this.selectedIndex = index;
		},
		async sendRecommendations() {
			this.loading = true;
			let recommendedVenues = [];
			let selectedOption = this.quickRecommendations[this.selectedIndex];
			let emailTemplate = this.emailTemplate;
			let emailSubject = this.emailSubjectMessage;

			// Add selected venues to recommendation queue
			for (const venue of selectedOption.venues) {
				recommendedVenues.push({
					id: venue.venue_id,
					space: "Whole Venue"
				});
			}

			await this.$store.dispatch("recommendations/sendRecommendation", {
				leadEventId: this.leadEventId,
				venues: recommendedVenues,
				template: emailTemplate,
				subject: emailSubject,
				portalLink: this.portalLoginLink,
				sendAsQuickRecommend: true,
			});

			await this.$store.dispatch('recommendations/getRecommendations', this.leadEventId);

			const results = await this.searchVenues(this.$route.params.id, this.leadEventId);
            const recommendableVenues = results?.data?.venues || {};
			if (Object.keys(recommendableVenues)?.length) {
                this.$store.commit('recommendations/updateKarenVenuesForListView', recommendableVenues);
			}

			this.$emit("close");

			this.loading = false;
		},
	},
	watch: {
		leadInfo: function () {
			this.getPortalLink(this.leadInfo.lead_id);
		}
	}
};
</script>
<style scoped>
.recommendation-container {
  display: flex;
  gap: 20px;
  justify-content: center;
  padding: 20px;
}

.option-box {
  flex: 1;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.option-box.selected {
  border: 2px solid #409eff;
  background: #ecf5ff;
}
.selected-option.hidden {
  display: none;
}
.selected-title {
  font-size: 1.2em;
  margin-top: -60px;
  display: block !important;
  text-align: center;
  color: #409eff;
}

.selected-option-number {
  margin-top: 34px;
}

.venue-list {
  list-style: none;
  padding: 0;
  margin: 15px 0 0 0;
}

.venue-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 0px;
  border-bottom: 1px solid #eaeaea;
}

.venue-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
}
</style>
